import axios from '@/axios'
import * as types from '../mutation-types'

export default {
	namespaced: true,
	
	state: {
		receives: [],
		receivesStatics: {
			averagePurchases: 0,
			sumPurchases: 0,
			sumWeightsOfPurchases: 0,
		},
	},

	actions: {
		fetchAll({ commit }, { date, status, providerId, orderByDate, orderByWeight, page, perPage }) {
			return axios.get('/receives', { params: { date, status, providerId, orderByDate, orderByWeight, page, perPage, sortByCreatedAt: true, nonDeleted: true } })
		},

		fetchById({ commit }, { id, IsPurchase }) {
			return axios.get(`/receives/${id}`);
		},

		fetchReceivesStatics({ commit }, { providerId, date, status }) {
			return axios.get('/receives/purchaseStatics', { params: { providerId, date, status } }).then(data => {
				commit(types.STORE_RECEIVES_STATICS, data);
				return data;
			})
		},

		fetchReport({ commit }, { date, lot, page, perPage }) {
			return axios.get('/receives/report', {
				params: { date, lot, page, perPage, sortByCreatedAt: true, nonDeleted: true }
			})
		},

		create({ commit }, { purchaseId, lot, date, income, quality, qqNetWeight, price, totalPurchase, specialInvoice, creditNote, pacoReference, note }) {
			return axios.post('/receives', { purchaseId, lot, date, income, quality, qqNetWeight, price, totalPurchase, specialInvoice, creditNote, pacoReference, note })
		},

		update({ commit }, { id, purchaseId, lot, date, ownerId, income, quality, qqNetWeight, price, totalPurchase, specialInvoice, creditNote, pacoReference, note, items, humidity, excludeFromStatistics }) {
			return axios.put(`/receives/${id}`, { purchaseId, lot, date, ownerId, income, quality, qqNetWeight, price, totalPurchase, specialInvoice, creditNote, pacoReference, note, items, humidity, excludeFromStatistics })
		},

		delete({ commit }, { id }) {
			return axios.delete(`/receives/${id}`)
		},

		fetchStatisticsTotal({ commit }, { date, status, lot }) {
			return axios.get('/receives/report/summary', { params: { date, status, lot } }).then(data => {
				return data;
			})
		},

		reset({ commit }) {
			commit(types.RESET);
		}
	},

	mutations: {
		[types.STORE_RECEIVES_STATICS](state, statics) {
			state.receivesStatics.averagePurchases = statics.averagePurchases;
			state.receivesStatics.sumPurchases = statics.sumPurchases;
			state.receivesStatics.sumWeightsOfPurchases = statics.sumWeightsOfPurchases;
		},

		[types.RESET](state, statics) {
			state.receivesStatics.averagePurchases = 0;
			state.receivesStatics.sumPurchases = 0;
			state.receivesStatics.sumWeightsOfPurchases = 0;
		}
	}
}